import React, { useMemo, useState } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { LoadableImageComponant, Spinner , PermissionsComponent  } from '../../../../../Components';
import { CopyToClipboardComponents } from '../../../../../ReusableComponents/UtilityComponents';
import { CallMade, LocalOffer, ShowChart } from '@material-ui/icons';
import useFetchData from '../../../../../Hooks/useFetchData';
import CreateLeadDialog from '../../../../../Components/CreateLeadDialog/CreateLeadDialog';
import AddActivityDialog from '../../ClientsTrackingUtilities/Components/AddActivityDialog';
import {
  getDownloadableLink,
  showError,
  showSuccess,
  returnPropsByPermissions 
} from '../../../../../Helper';
import {
  BulkUpdateGeneralClientTrackingForSingle,
  CreateGeneralClientTrackingActivity,
  GetContactById,
} from '../../../../../Services';
import { DefaultImagesEnum } from '../../../../../Enums';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { LookupSelect } from '../../../ActivitiesTypeView/ActivitiesTypeManagementView/DialogManagementViewComponent/DialogManagementConrtolComponent/LookupSelect';
import ActivitiesTimeline from '../../ClientsTrackingUtilities/Sections/ActivitiesTimeline';
import { useKeyGenerator } from '../../../../../Hooks/keyGenerator';
import InquiryStatusSelect from './InquiryStatusSelect';
import { ClientsTrackingPermissions } from "../../../../../Permissions"; 
import LinkToOfferDialog from '../../ClientsTrackingUtilities/Components/LinkToOfferDialog';

const styles = makeStyles({
  container: {
    '& img': {
      width: '72px',
      height: '72px',
    },
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '18px',
    '& h2': { fontWeight: 600, fontSize: '18px', color: '#3B72D9' },
    '& .copy-container': {
      width: 'fit-content !important',
    },
    '& .contact-name': {
      fontWeight: 600,
      fontSize: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      '& .MuiSvgIcon-fontSizeSmall': {
        fontSize: '16px',
        fill: '#344054',
        alignSelf: 'center',
      },
    },
    '& .btn': {
      borderRadius: '9999px',
      padding: '8px 12px',
      display: 'flex',
      justifyContent: 'space-center',
      alignItems: 'center',
      gap: '4px',
    },
    '& .theme-outline': {
      border: '1px solid #3B72D9 !important',
      color: '#3B72D9 !important',
    },
    '& .card-container': {
      overflow: 'auto',
      maxHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      padding: '8px',
      border: '1px solid #EAECF0 !important',
      shadowBox: '0px 1px 2px rgba(16, 24, 40, 0.05)',
      borderRadius: '12px',
      '& .card-title': {
        fontWeight: 600,
        fontSize: '16px',
        color: '#2D3E50',
      },
      '& .card-content': {
        fontWeight: 400,
        fontSize: '14px',
        color: '#475467',
      },
      '& .card-details': {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      },
    },
    '& .divider': {
      margin: '20px 0',
      backgroundColor: '#ccc !important',
      height: '1px !important',
      border: 'none !important',
    },
    '& .actions-container-inquiry': {
      display: 'flex',
      flexDirection: 'row',
      justifyItems: 'flex-between',
      rowGap: '8px',
      flexWrap: 'wrap',
      alignItems: 'center',
      margin: 0,
      padding: 0,
    },
  },
});

const GeneralInquirySideCard = ({
  clientEmail,
  clientPhone,
  contactName,
  contactId,
  generalClientTrackingId,
  enquiryDate,
  enquiryDescription,
  sourceOfLead,
  inquiryStatus,
  sourceOfLeadId,
  onSave,
}) => {
  const { data: contact, loading } = useFetchData(GetContactById, contactId);
  const [key, refresh] = useKeyGenerator();

  const [generalInquiry, setGeneralInquiry] = useState({
    clientEmail,
    clientPhone,
    contactName,
    contactId,
    generalClientTrackingId,
    enquiryDate,
    enquiryDescription,
    sourceOfLead,
    inquiryStatus,
    sourceOfLeadId,
  });
  const classes = styles();
  const [openCreateLeadDialog, setOpenCreateLeadDialog] = useState(false);
  const [openActivitiesDialog, setOpenActivitiesDialog] = useState(false);
  const [openLinkToOfferDialog, setOpenLinkToOfferDialog] = useState(false);
  const contactDetails = useMemo(
    () =>
      contact.contactJson ? JSON.parse(contact.contactJson).contact : null,
    [contact]
  );

  const onSaveActivityHandler = async (data) => {
    try {
      data.activityTypeId = data.activityType.activityTypeId;
      await CreateGeneralClientTrackingActivity(data);
      showSuccess('create successfully');
      refresh();
    } catch (error) {
      showError('create error');
    } finally {
      setOpenActivitiesDialog(false);
    }
  };

  const updateGeneralInquiryHandler = async () => {
    try {
      await BulkUpdateGeneralClientTrackingForSingle(generalInquiry);
      onSave();
      showSuccess('updated successfully');
    } catch (error) {
      showError('update error');
    }
  };
  if (loading || !contactDetails) {
    return <Spinner isActive isAbsolute />;
  }
  return (
    <div className={classes.container}>
      <h2>Contact Profile</h2>
      <div className="flex gap-1">
        <LoadableImageComponant
          src={
            contactDetails.contact_type_id === 1
              ? getDownloadableLink(
                  contactDetails.contact_image?.["Image Upload"]?.[0].uuid
                ) ?? DefaultImagesEnum.individual.defaultImg
              : getDownloadableLink(
                  contactDetails?.company_logoimage?.["Company Logo"]?.[0]?.uuid
                ) ?? DefaultImagesEnum.corporate.defaultImg
          }
        />
        <div className="d-flex-column gap-6 py-2">
          <span className="contact-name ">
            {contactName}
            <Link
              to={`/home/Contacts-CRM/contact-profile-edit?formType=${contactDetails?.contact_type_id}&id=${contactId}`}
              target="_blank"
              className="flex"
            >
              <CallMade fontSize="small" />
            </Link>
          </span>
          <CopyToClipboardComponents
            data={contactId}
            childrenData={`#${contactId}`}
          />
          {contactDetails?.landline_number?.phone && (
            <CopyToClipboardComponents
              data={contactDetails?.landline_number.phone}
              childrenData={
                <div className="flex gap-4 fa-center">
                  <span className="mdi mdi-phone"></span>
                  {contactDetails.landline_number.phone}
                </div>
              }
            />
          )}
          {contactDetails?.mobile?.phone && (
            <CopyToClipboardComponents
              data={contactDetails.mobile.phone}
              childrenData={
                <div className="flex gap-4 fa-center">
                  <span class="mdi mdi-phone-outline"></span>
                  {contactDetails.mobile.phone}
                </div>
              }
            />
          )}
          {contactDetails?.email_address?.email && (
            <CopyToClipboardComponents
              data={contactDetails.email_address.email}
              childrenData={
                <div className="flex gap-4 fa-center">
                  <span class="mdi mdi-email-outline"></span>
                  {contactDetails.email_address.email}
                </div>
              }
            />
          )}
        </div>
      </div>
      <div className="actions-container-inquiry">
        <PermissionsComponent
          permissionsList={Object.values(ClientsTrackingPermissions)}
          permissionsId={
            ClientsTrackingPermissions.CreateLeadForGeneralInquiry.permissionsId
          }
        >
          <Button
            className="btns theme-outline"
            onClick={() => setOpenCreateLeadDialog(true)}
          >
            <span className="mdi mdi-plus" />
            Create Lead
          </Button>
        </PermissionsComponent>
        <PermissionsComponent
          permissionsList={Object.values(ClientsTrackingPermissions)}
          permissionsId={
            ClientsTrackingPermissions.AddActivityForGeneralInquiry
              .permissionsId
          }
        >
          <Button
            className="btns theme-solid"
            onClick={() => setOpenActivitiesDialog(true)}
          >
            <ShowChart className="mdi " />
            Add Activity
          </Button>
        </PermissionsComponent>
        <Button
          className="btns theme-transparent"
          onClick={() => setOpenLinkToOfferDialog(true)}
        >
          <LocalOffer className="mdi " />
          Link to Offer
        </Button>
      </div>
      <div className="card-container">
        <span className="card-title">General inquiry details</span>
        <div className="card-details">
          <span>
            Inquiry Date&nbsp;
            <strong>{moment(enquiryDate).format("DD-MM-YYYY, HH:MM A")}</strong>
          </span>
          {enquiryDescription && (
            <span>
              Inquiry description&nbsp;
              <br />
              <strong>{enquiryDescription}</strong>
            </span>
          )}
          <div className="d-flex flex-wrap fj-between fa-center gap-1 mt-1">
            <InquiryStatusSelect
              onChange={(e) =>
                setGeneralInquiry({
                  ...generalInquiry,
                  inquiryStatus: e,
                })
              }
              label={"Inquiry Status"}
              status={generalInquiry.inquiryStatus}
            />
            <LookupSelect
              lookupName={"sourceOfLead"}
              value={generalInquiry.sourceOfLeadId}
              labelValue={"Source of Lead"}
              onSelectChanged={(value) =>
                setGeneralInquiry({
                  ...generalInquiry,
                  sourceOfLeadId: value,
                })
              }
            />
          </div>
        </div>
      </div>
      <div className="card-container">
        <span className="card-title">Activity Timeline</span>
        <div className="card-details">
          <ActivitiesTimeline
            generalClientTrackingId={generalClientTrackingId}
            key={key}
          />
        </div>
      </div>
      <div className="d-flex-column">
        <hr className={"divider"} />
        <div className="d-flex fj-end">
          <Button
            className="btns theme-outline"
            onClick={() =>
              setGeneralInquiry({
                clientEmail,
                clientPhone,
                contactName,
                contactId,
                generalClientTrackingId,
                enquiryDate,
                enquiryDescription,
                sourceOfLead,
                inquiryStatus,
                sourceOfLeadId,
              })
            }
          >
            Cancel
          </Button>
          <Button
            className="btns theme-solid"
            onClick={updateGeneralInquiryHandler}
          >
            Save Changes
          </Button>
        </div>
      </div>
      <CreateLeadDialog
        contactId={contactId}
        open={openCreateLeadDialog}
        setOpen={setOpenCreateLeadDialog}
      />
      <AddActivityDialog
        contactId={contactId}
        generalClientTrackingId={generalClientTrackingId}
        open={openActivitiesDialog}
        onSave={onSaveActivityHandler}
        onClose={() => setOpenActivitiesDialog(false)}
      />
      <LinkToOfferDialog
        open={openLinkToOfferDialog}
        onClose={() => setOpenLinkToOfferDialog(false)}
        contactId={contactId}
        clientEmail={clientEmail}
        clientPhone={clientPhone}
        contactName={contactName}
      />
    </div>
  );
};
export default GeneralInquirySideCard;
